import { render, staticRenderFns } from "./DeadlinesList.vue?vue&type=template&id=b64ad37c"
import script from "./DeadlinesList.vue?vue&type=script&lang=js"
export * from "./DeadlinesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports